/* src/app/shared/clearing/clearing-merge-popup/clearing-merge-popup.component.scss */
:host {
  height: 100%;
  margin: 1rem;
}
:host,
:host phscw-clearing-display,
:host phscw-clearing-display ::ng-deep phscw-grid {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
}
:host .cw-merge-error {
  color: var(--color-accent);
  text-align: right;
}
/*# sourceMappingURL=clearing-merge-popup.component.css.map */
